import {Address2ComponentValue} from '../component/address2-component.domain';

export type PropertyOwnerWithAddressValue = {
  propertyOwner: boolean,
  address?: Address2ComponentValue,
  propertyValue?: number,
  mortgageValue?: number,
} | null;
